<div class="file-upload">
    <!-- Files already uploaded -->
    @if ((files$ | async)?.length ?? 0 > 0) {
        <ul class="file-list mb-2">
            @for (file of files$ | async; track file) {
                @if (!isFileSelectedForDeletion(file.id)) {
                    <li class="file-row">
                        <div class="file-row__file">
                            <span class="material-symbols-outlined icon-md" aria-hidden="true">description</span>
                            <div class="file-info">
                                <div class="file-info__name" [pTooltip]="file.name" tooltipPosition="top">
                                    {{ file.name }}
                                </div>
                                <div class="file-info__size">{{ formatFileSize(file.size) }}</div>
                            </div>
                        </div>
                        <div class="file-row__actions">
                            <p-button
                                icon="ms ms-download"
                                severity="secondary"
                                [text]="true"
                                [rounded]="true"
                                size="small"
                                [ariaLabel]="'components.file_upload.download' | translate"
                                [pTooltip]="'components.file_upload.download' | translate"
                                [disabled]="isDisabled"
                                (onClick)="onDownload(file)" />
                            @if (!readOnly) {
                                <p-button
                                    icon="ms ms-delete"
                                    severity="secondary"
                                    [text]="true"
                                    [rounded]="true"
                                    size="small"
                                    [ariaLabel]="'components.file_upload.delete' | translate"
                                    [pTooltip]="'components.file_upload.delete' | translate"
                                    [disabled]="isDisabled"
                                    (onClick)="toggleFileForDeletion(file.id)" />
                            }
                        </div>
                    </li>
                }
            }
        </ul>
    }

    <!-- Files selected to upload -->
    @if (selectedFiles.length > 0) {
        <ul class="file-list file-list--to-upload mb-2">
            @for (file of selectedFiles; track file; let i = $index) {
                <li class="file-row">
                    <div class="file-row__file">
                        <span class="material-symbols-outlined icon-md file-row__icon--upload" aria-hidden="true"
                            >upload_file</span
                        >
                        <div class="file-info">
                            <div class="file-info__name" [pTooltip]="file.name" tooltipPosition="top">
                                {{ file.name }}
                            </div>
                            <div class="file-info__size">{{ formatFileSize(file.size) }}</div>
                        </div>
                    </div>
                    <p-button
                        icon="ms ms-close"
                        severity="secondary"
                        [text]="true"
                        [rounded]="true"
                        size="small"
                        [ariaLabel]="'components.file_upload.remove' | translate"
                        [pTooltip]="'components.file_upload.remove' | translate"
                        (onClick)="removeSelectedFile(i)" />
                </li>
            }
        </ul>
    }

    <!-- Files selected for deletion -->
    @if (filesToDelete.length > 0) {
        <ul class="file-list file-list--to-delete mb-2">
            @for (file of files$ | async; track file) {
                @if (isFileSelectedForDeletion(file.id)) {
                    <li class="file-row">
                        <div class="file-row__file">
                            <span class="material-symbols-outlined icon-md file-row__icon--delete" aria-hidden="true"
                                >scan_delete</span
                            >
                            <div class="file-info">
                                <div class="file-info__name" [pTooltip]="file.name" tooltipPosition="top">
                                    {{ file.name }}
                                </div>
                                <div class="file-info__size">{{ formatFileSize(file.size) }}</div>
                            </div>
                        </div>
                        <p-button
                            icon="ms ms-close"
                            severity="secondary"
                            [text]="true"
                            [rounded]="true"
                            size="small"
                            [ariaLabel]="'components.file_upload.keep' | translate"
                            [pTooltip]="'components.file_upload.keep' | translate"
                            (onClick)="toggleFileForDeletion(file.id)" />
                    </li>
                }
            }
        </ul>
    }

    <!-- Loading spinner -->
    @if (loading$ | async) {
        <div class="file-upload__loading" role="status" [attr.aria-label]="'common.loading' | translate">
            <span class="material-symbols-outlined icon-lg ms-spin" aria-hidden="true">progress_activity</span>
        </div>
    }

    <!-- Hidden input file -->
    <input
        type="file"
        #fileInput
        (change)="onFileSelected($event)"
        accept=".pdf,.docx,.xlsx,.csv,.jpeg,.png,.txt"
        class="hidden"
        [disabled]="loading$ | async" />

    <!-- Add file button -->
    @if (!readOnly) {
        <p-button
            icon="ms ms-add"
            severity="secondary"
            [text]="true"
            [label]="'components.file_upload.add_file' | translate"
            [disabled]="isDisabled"
            (onClick)="fileInput.click()" />
    }

    <!-- Error message -->
    @if (hasErrors$ | async) {
        <small class="p-error block">{{ 'components.file_upload.error' | translate }}</small>
    }
</div>
